export default "__VITE_ASSET__CQS9Axrv__"